import { parseAsStringLiteral, useQueryState } from 'nuqs';

export const DISPOSITION_VIEWS = ['tag', 'woche'] as const;
export type DispositionView = (typeof DISPOSITION_VIEWS)[number];

export interface DispositionViewState {
  value: DispositionView;
  setValue: (view: DispositionView) => void;
}

/**
 * Which disposition view is showing, persisted as `?view=tag|woche`.
 *
 * The week is **read-only**: nothing can be placed on it. That does not make it unavailable while
 * planning or rescheduling — it is where the dispatcher looks for a free day, and a click on a day
 * leads back to the day board (`useDispositionWeek.openDay`) with the planning params and the draft
 * intact, which `DispositionPage` keeps alive across both views.
 *
 * Options match the rest of the page: replace rather than push, so the back button leaves the
 * calendar instead of walking through every toggle.
 */
export function useDispositionView(): DispositionViewState {
  const [rawView, setView] = useQueryState(
    'view',
    parseAsStringLiteral(DISPOSITION_VIEWS).withDefault('tag').withOptions({
      history: 'replace',
      shallow: true,
      clearOnDefault: true,
    }),
  );

  return {
    value: rawView,
    setValue: (view) => {
      void setView(view);
    },
  };
}
